import { render } from "./NavbarDropdownItemLink.vue?vue&type=template&id=3c694ead&scoped=true&ts=true&lang=pug"
import script from "./NavbarDropdownItemLink.vue?vue&type=script&lang=ts"
export * from "./NavbarDropdownItemLink.vue?vue&type=script&lang=ts"

import "./NavbarDropdownItemLink.vue?vue&type=style&index=0&id=3c694ead&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c694ead"]])

export default __exports__